import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSSEStore } from '../../../stores/sseStore';
import { Loader2 } from 'lucide-react';

function EnrichmentProgressPanel() {
  const { t } = useTranslation();
  const { subscribe } = useSSEStore();
  const [progress, setProgress] = useState<Map<number, any>>(new Map());

  useEffect(() => {
    const unsub = subscribe('enrichment:progress', (data: any) => {
      setProgress(prev => {
        const next = new Map(prev);
        const p = data;
        if (p.status === 'complete' || p.status === 'error') {
          // Remove after 3 seconds
          setTimeout(() => setProgress(pr => {
            const n = new Map(pr);
            n.delete(p.queueId);
            return n;
          }), 3000);
        }
        next.set(p.queueId, p);
        return next;
      });
    });
    return unsub;
  }, [subscribe]);

  if (progress.size === 0) return null;

  return (
    <div className="bg-[var(--color-bg-secondary)] rounded-lg border border-[var(--color-border)] p-4 space-y-3">
      <h3 className="text-sm font-medium text-[var(--color-text)] flex items-center gap-2">
        <Loader2 size={16} className="animate-spin text-blue-500" />
        {t('pub.enrichmentProgress')} ({progress.size})
      </h3>
      {Array.from(progress.values()).map((p: any) => (
        <div key={p.queueId} className="flex items-center gap-3 text-sm">
          <span className="font-mono text-teal-500 w-24">{p.asin}</span>
          <div className="flex-1">
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs text-[var(--color-text-secondary)]">
                {p.stepName} ({p.currentStep}/{p.totalSteps})
              </span>
              <span className={`text-xs font-medium ${
                p.status === 'complete' ? 'text-green-500' :
                p.status === 'error' ? 'text-red-500' : 'text-blue-500'
              }`}>
                {p.status === 'complete' ? String.fromCharCode(10003) : p.status === 'error' ? String.fromCharCode(10007) : '...'}
              </span>
            </div>
            <div className="w-full h-1.5 bg-[var(--color-bg-tertiary)] rounded-full overflow-hidden">
              <div
                className={`h-full rounded-full transition-all duration-300 ${
                  p.status === 'complete' ? 'bg-green-500' :
                  p.status === 'error' ? 'bg-red-500' : 'bg-blue-500'
                }`}
                style={{ width: `${(p.currentStep / p.totalSteps) * 100}%` }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export { EnrichmentProgressPanel };
